import { action } from 'mobx';
import { PersonEditForm } from 'application/person/forms';
import { BaseEditViewStore, BaasicDropdownStore } from 'core/stores';
import { applicationContext } from 'core/utils';
import { PersonService } from 'application/person/services';
import { ImportService } from 'application/import/services';
import _ from "lodash";
@applicationContext
class PersonEditViewStore extends BaseEditViewStore {
    constructor(rootStore) {
        const id = rootStore.routerStore.routerState.params.id;
        const service = new PersonService(rootStore.application.baasic.apiClient);

        super(rootStore, {
            name: 'role',
            id: id,
            Form: PersonEditForm,
            authorization: 'portalSection.update',
            actions: () => {
                return {
                    get: async (id, opts) => {
                        const response = await service.get(id, opts);
                        return response.data;
                    },
                    update: async (resource) => {
                        const response = await service.update(resource);
                        return response.data;
                    },
                    create: async (resource) => {
                        const response = await service.create(resource);
                        return response.data;
                    }
                }
            },
            FormClass: PersonEditForm,
        });

        this.personService = service;
        this.importService = new ImportService(rootStore.application.baasic.apiClient);
        this.userStore = this.createPersonDropdownStore(this.onUserChange);
    }

    @action.bound
    createPersonDropdownStore() {
        return new BaasicDropdownStore({
            filterable: true,
            textField: "name",
        }, {
            fetchFunc: async (term) => {
                const response = await this.importService.getImportUsers(term);
                return _.map(response.item, user => {
                    return {
                        id: user.id,
                        name: `${(user.firstName || '')} ${(user.lastName || '')}`
                    };
                })
            }
        });
    }

    @action.bound
    async onInit({ initialLoad }) {
        if (!initialLoad) {
            this.rootStore.routerStore.goBack();
        }
    }
    @action.bound
    async updateResource(resource) {
        if (!this.actions.update) return;

        this.form.setFieldsDisabled(true);
        try {
            if (this.translationStore) {
                this.translationStore.applyMetadata(resource);
            }

            await this.actions.update({
                id: this.id,
                ...resource
            });

            this.form.setFieldsDisabled(false);

            await this.rootStore.routerStore.goBack();
            await setTimeout(() => this.rootStore.notificationStore.success("PERSON.EDIT.SUCCESS"), 10);
        }
        catch (err) {
            this.form.setFieldsDisabled(false);
            this.rootStore.notificationStore.error(
                err && err.data && err.data.message ? (err.data.message === 'Resource already exists.' ? "Person with this first and last name already exists." : err.data.message ) : `Error occurred while trying to update a person`
            );
        }
    }
    @action.bound
    notifySuccessCreate() {
        this.rootStore.notificationStore.success('PERSON.CREATE.SUCCESS');
    }

    @action.bound
    async createResource(resource) {
        if (!this.actions.create) return;

        this.form.setFieldsDisabled(true);
        try {
            if (this.translationStore) {
                this.translationStore.applyMetadata(resource);
            }

            await this.actions.create(resource);

            this.form.setFieldsDisabled(false);

            await this.rootStore.routerStore.goBack();
            await setTimeout(() => this.notifySuccessCreate(), 10);
        }
        catch (err) {
            this.form.setFieldsDisabled(false);
            this.rootStore.notificationStore.error(
                err && err.data && err.data.message ? (err.data.message === 'Resource already exists.' ? "Person with this first and last name already exists." : err.data.message )  : `Error occurred while trying to create a person`
            );
        }
    }

}

export default PersonEditViewStore;
